import Core from '../../../Core/Core';
import { HudActions, HudEmitter } from '../../../Managers/Hud/HudEmitter';
import { Actions } from '../../../State/Actions/Actions';
import DateUtils from '../../../Utils/DateUtils';
import { TextButton } from '../../Shared/Buttons/TextButton';

export class SocialGiftButton extends TextButton {
    public enabled: boolean = true;
    private dragging: boolean = false;
    private readonly friendId: string;
    private readonly action: HudActions;
    private btnText: string;

    constructor(
        width: number,
        height: number,
        btnText: string,
        friendId: string,
        action: HudActions,
        color?: number
    ) {
        super({ width, height, btnText, color });

        this.btnText = btnText;
        this.friendId = friendId;
        this.action = action;

        this.disable();
        this.on('trigger', this.handlePointerDown.bind(this));
    }

    public updateTimer(timeRemaining: number): void {
        if (timeRemaining && timeRemaining > 0) {
            if (this.enabled) {
                this.disable();
            }
            this.text = DateUtils.format(timeRemaining, 'hh:mm:ss');
        } else {
            if (!this.enabled) {
                this.text = this.btnText;

                if (this.action === HudActions.SOCIALHUB_SEND_GIFT && timeRemaining) {
                    Core.store.dispatch(Actions.resetSendGift(this.friendId));
                }
                if (this.action === HudActions.SOCIALHUB_REQUEST_GIFT && timeRemaining) {
                    Core.store.dispatch(Actions.resetRequestGift(this.friendId));
                }
                this.enable();
            }
        }
    }

    public setDragging(bool: boolean) {
        this.dragging = bool;
    }

    /**
     * Set as interactable, show coins, hide timer and start rays animation.
     */
    private enable(): void {
        this.enabled = true;
        this.interactive = true;
        this.buttonMode = true;
        this.alpha = 1;
    }

    /**
     * Set as non-interactable, hide coins, show timer and kill rays animation.
     */
    private disable(): void {
        this.enabled = false;
        this.interactive = false;
        this.buttonMode = false;
        this.alpha = 0.3;
    }

    private async handlePointerDown(): Promise<void> {
        if (!this.dragging) {
            this.disable();
            HudEmitter.instance.emit(this.action, this.friendId);
        }
    }
}
